/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FolderCheckIcon20Solid = forwardRef('FolderCheckIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 4.5A1.5 1.5 0 0 1 3.5 3h4.3a1.5 1.5 0 0 1 1.205.607l.807 1.09a.75.75 0 0 0 .603.303H15a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V4.5Zm12.447 4.744a.9.9 0 0 0-1.273-1.272l-4.367 4.366a.1.1 0 0 1-.141 0l-1.84-1.84a.9.9 0 1 0-1.273 1.273l1.84 1.84a1.9 1.9 0 0 0 2.687 0l4.367-4.367Z" })));
});
